import e from "react";
import { Icon as n } from "../../../general/Icon/Icon.js";
var t = function t(_t) {
  var a = _t.isCollapsed,
    r = _t.onToggle;
  return e.createElement("button", {
    className: "sidebar__navigation-resize-button",
    onClick: function onClick() {
      null == r || r();
    }
  }, a ? e.createElement(n, {
    name: "angle-right",
    regular: !0
  }) : e.createElement(n, {
    name: "angle-left",
    regular: !0
  }));
};
export { t as NavigationResizeButton };